'use client'

import SvgArrowRight from '@/icons/thin/ArrowRight'
import { popupEventName } from '@/lib/popups/constants'
import type { SitePopup } from '@/lib/popups/types'

import { popupClickTracking } from './click-tracking'
import { GeneralPopupPhoneLink } from './general-popup-phone-link'

interface GeneralPopupActionsProps {
  popup: SitePopup
  hasImage: boolean
  onCtaClick: () => void
  reason?: string | null
}

export const GeneralPopupActions = ({ popup, hasImage, onCtaClick, reason }: GeneralPopupActionsProps) => (
  <div className="flex flex-col gap-3">
    {popup.ctaLabel ? (
      <a
        href={popup.url}
        target={popup.newTab ? '_blank' : undefined}
        rel="noopener noreferrer nofollow sponsored"
        {...popupClickTracking(reason)}
        data-event-name={popupEventName(popup.slug)}
        data-event-position={`${popup.slug}-button`}
        data-event-origin={popup.slug}
        data-event-product={popup.title ?? popup.slug}
        onClick={onCtaClick}
        className="group/btn bg-navy hover:bg-navy-90 flex w-full cursor-pointer items-center justify-center gap-2 rounded-lg py-3.5 text-sm font-bold text-white shadow-md transition-all focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-navy"
      >
        {popup.ctaLabel}
        <SvgArrowRight className="h-4 w-4 transition-transform group-hover/btn:translate-x-1" aria-hidden="true" />
      </a>
    ) : null}
    <GeneralPopupPhoneLink
      popup={popup}
      reason={reason}
      onCtaClick={onCtaClick}
      variant="button"
      className={hasImage ? 'flex md:hidden' : 'flex'}
    />
  </div>
)
